import { render, staticRenderFns } from "./outordersummary.vue?vue&type=template&id=a95abeac&scoped=true&"
import script from "./outordersummary.vue?vue&type=script&lang=js&"
export * from "./outordersummary.vue?vue&type=script&lang=js&"
import style0 from "./outordersummary.vue?vue&type=style&index=0&id=a95abeac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95abeac",
  null
  
)

export default component.exports